import { render, staticRenderFns } from "./OrderGD.vue?vue&type=template&id=72120d9b"
import script from "./OrderGD.vue?vue&type=script&lang=js"
export * from "./OrderGD.vue?vue&type=script&lang=js"
import style0 from "./OrderGD.vue?vue&type=style&index=0&id=72120d9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports